import React from 'react'
import { useInView } from 'react-hook-inview'

import { downloadBlob } from '../../../../../utilities'
import useStyles from './styles'

const Fallback = ({ name, media, onRender }) => {
  const [inViewRef, inView] = useInView()

  const classes = useStyles()

  // Stops loading spinner
  React.useEffect(() => {
    if (inView) {
      onRender()
    }
  }, [inView, onRender])

  return (
    <div ref={inViewRef} className={classes.root}>
      <div className={classes.text}>
        Your browser doesn't support viewing PDFs, try downloading instead.
      </div>

      <div onClick={() => downloadBlob(name, media)} className={classes.name}>
        {name}
      </div>
    </div>
  )
}

export default Fallback
